/**
 * Format a time range into a localized string using Intl.DateTimeFormat.
 *
 * If both times share the same AM or PM, show AM or PM only once at the end.
 * Otherwise, show AM and PM for both.
 *
 * @param time1 - Start time in HH:mm format (24-hour)
 * @param time2 - End time in HH:mm format (24-hour)
 * @returns A formatted time range string
 * @example
 * ```ts
 * formatTimeRange('10:30', '11:45') // "10:30 - 11:45 AM"
 * formatTimeRange('09:00', '13:00') // "9:00 AM - 1:00 PM"
 * ```
 */
export function formatTimeRange(time1: string, time2: string): string {
  const formatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })

  const toDate = (timeStr: string): Date => {
    const [h, m] = timeStr.split(':').map(Number)
    return new Date(2000, 0, 1, h, m)
  }

  const start = formatter.format(toDate(time1))
  const end = formatter.format(toDate(time2))
  if (start.split(' ')[1] === end.split(' ')[1])
    return `${start.replace(/ [AP]M/, '')} - ${end}`
  return `${start} - ${end}`
}
